// MyCourses.tsx
import React, { useEffect } from 'react';
import './MyCourses.css';
import CourseCard from '@/Components/CourseCard/CourseCard';
import { useLearningsStore } from '@/stores/LearnerStore/LearningsStore';
import { LoadingSpinner, ErrorDisplay } from '@/Components/common';

const MyCourses: React.FC = () => {
  const {
    myCourses,
    loadingMyCourses,
    errorMyCourses,
    fetchMyCourses,
  } = useLearningsStore();

  // Fetch data on mount
  useEffect(() => {
    fetchMyCourses();
  }, [fetchMyCourses]);

  // Loading state
  if (loadingMyCourses) {
    return (
      <LoadingSpinner
        fullScreen
        size="lg"
      />
    );
  }

  // Error state
  if (errorMyCourses) {
    return (
      <ErrorDisplay
        fullScreen
        title="Failed to Load My Courses"
        message={errorMyCourses}
        type="error"
        showRetry
        onRetry={fetchMyCourses}
      />
    );
  }

  return (
    <div className="my-courses-container">
      <div className="my-courses-header">
        <h1>My Courses</h1>
        <p>Continue your learning journey and track your progress</p>
      </div>
      <div className="my-courses-grid">
        {myCourses?.map((course) => (
          <CourseCard key={course.id} course={course} />
        ))}
      </div>
    </div>
  );
};

export default MyCourses;
